<template>
    <div class="aipage">
      <extraPage :content="content" @change="changeTab"></extraPage>
    </div>
</template>
<script>
import extraPage from '@/components/extraPage.vue'
/* eslint-disable */
export default {
    components: {
        extraPage,
    },
    data() {
        return {
          content:{}
      }
    },
    created(){
        this.changeTab('easyConstruct')
    },
    methods: {
        changeTab(index) {
            if (index === 'easyConstruct') {
                this.content = {
                    bannerBtnList:[{ label:'易构算力调度平台',value:'easyConstruct'},{ label:'算云一体化平台',value:'cloud'}],
                    bannerTitle: require("@/assets/images/bussiness/paas-easy/paasTitle.png"),
                    bannerSmallTitle: '高效、智能的云原生 GPU 集群管理与算力调度平台，实现资源高效利用与任务快速执行',
                    productOverviewTitle: '',
                    productOverviewImg: require("@/assets/images/bussiness/paas-easy/paas_wrapbg1.png"),
                    productArchitectureImg2: require("@/assets/images/bussiness/paas-easy/paas_wrapbg2.png"),
                    productCapacityImg: require("@/assets/images/bussiness/paas-easy/paas_wrapbg3.png"),
                    productOverviewContent: '异构算力调度平台是针对多元化计算需求设计的智能资源管理中枢，通过创新的调度引擎打破硬件架构壁垒，实现跨CPU、GPU、NPU、FPGA等异构计算资源的统一纳管与动态调配。平台采用智能负载预测算法，动态匹配任务需求与算力特性，将AI训练、科学计算、图形渲染等任务自动分配至最优硬件，资源利用率提升40%以上。支持混合云部署模式，提供可视化监控界面和API接口，兼容Kubernetes等主流编排工具，帮助用户构建低成本、高响应的算力网络，典型应用于基因测序、自动驾驶仿真、超算中心等场景，平均可降低40%的算力采购成本.',
                    aiContentList: [
                        { title: 'AI 模型训练', wrapPic: require("@/assets/images/bussiness/paas-easy/wrapbg1.png"), content:'高效调度与管理GPU资源，加速模型训练过程，提升训练效率。' },
                        { title: '云原生应用开发', wrapPic: require("@/assets/images/bussiness/paas-easy/wrapbg2.png"), content:'简化云原生环境下的GPU集群管理，助力开发者快速构建与部署应用' },
                        { title: '高性能计算', wrapPic: require("@/assets/images/bussiness/paas-easy/wrapbg3.png"), content:'支持大规模并行计算任务，优化网络通信，确保高性能计算任务无缝对接。' },
                        { title: '数据科学与分析', wrapPic: require("@/assets/images/bussiness/paas-easy/wrapbg4.png"), content:'提供灵活算力资源，满足数据科学与分析任务对算力的多样化需求。' },
                    ],
                    productGoodsList: [
                        { title: '云原生深度整合', wrapPic: require("@/assets/images/bussiness/paas-easy/wrapbg6.png"), content:'与云原生环境无缝对接，大幅降低GPU集群及节点的运维难度，提升管理效率，释放技术团队生产力以聚焦核心业务开发。' },
                        { title: '智能资源调配', wrapPic: require("@/assets/images/bussiness/paas-easy/wrapbg7.png"), content:'通过多维度调度策略和资源优化机制，动态适配各类计算任务需求，缩短模型训练周期，最大化硬件资源利用率。' },
                        { title: '可视化运维洞察', wrapPic: require("@/assets/images/bussiness/paas-easy/wrapbg8.png"), content:'提供集群资源实时监测与智能分析功能，辅助动态调整资源配置策略，保障系统持续稳定高性能输出。' },
                        { title: '超大规模管控', wrapPic: require("@/assets/images/bussiness/paas-easy/wrapbg9.png"), content:'统一纳管异构计算设备，支持万级GPU卡协同调度，实现跨团队、多任务的高效并行计算资源统筹。' },
                    ],
                    productCapacityList:[
                        { title:'统一化云原生管控', content:'实现跨品牌GPU集群/节点/用户的全维度监控，提供细粒度操作追溯能力，配合运行日志与审计双链路记录，构建安全可控的异构算力管理体系。' },
                        { title:'超大规模智能调度', content:'基于分布式调度引擎，支持万级GPU卡资源池的弹性管理，通过智能安置组策略动态优化任务编排，显著缩短AI训练周期。' },
                        { title:'精细化算力分割', content:'突破单卡物理限制，支持多实例并行、显存动态切分及跨节点协同计算，兼容主流GPU品牌，可按需自定义算力分配规格。' },
                        { title:'策略驱动型调度', content:'集成K8s/Volcano等主流调度器，支持自定义策略引擎，智能匹配任务与资源配比，实现"申请-执行-释放"全自动化资源生命周期管理。' },
                        { title:'弹性算力池架构', content:'支持构建混合共享/独占式资源池，通过时分复用技术实现单卡多租户隔离使用，兼顾团队协作效率与关键项目资源保障需求。' },
                        { title:'极简任务交付', content:'提供可视化分布式任务提交界面，预置主流计算框架模板，结合镜像加速技术将环境部署效率提升80%以上。' },
                    ],
                    caseList: [
                        { title: '青海智算中心', content:'训、推、用一体化平台，提供全方位的AI建模解决方案', wrapPic: require("@/assets/images/bussiness/paas-easy/paas_wrapbg4.png"),  },
                    ]
                }
            }else{
                this.content = {
                    bannerBtnList:[{ label:'易构算力调度平台',value:'easyConstruct'},{ label:'算云一体化平台',value:'cloud'}],
                    bannerTitle: require("@/assets/images/bussiness/paas/paasTitle.png"),
                    bannerSmallTitle: '通用、智能、超算、边缘计算"四算融合"，实现跨厂商、跨地域、跨架构的异构算力资源智能调度与统一编排',
                    productOverviewTitle: '',
                    productOverviewImg: require("@/assets/images/bussiness/paas/paas_wrapbg1.png"),
                    productArchitectureImg2: require("@/assets/images/bussiness/paas/paas_wrapbg2.png"),
                    productCapacityImg: require("@/assets/images/bussiness/paas/paas_wrapbg3.png"),
                    productOverviewContent: '算云一体化平台通过"算力伙伴共赢计划"整合第三方优质算力资源，构建集通用计算、智能计算、超算及边缘计算于一体的"全国算力一张网"。该平台具备超大规模集群管理能力，融合异构计算、高速存储、无损网络、算力加速和高效运营五大核心技术，通过标准化算力插件和算力网关实现社会闲散算力的云化纳管与安全接入。平台创新性地实现算数协同（算随数动、数随算动），建立统一的算力度量体系，并基于实时算网状态感知进行智能资源编排调度，为各类应用场景提供最优算力解决方案。',
                    aiContentList: [
                        { title: '大模型分布式训练', wrapPic: require("@/assets/images/bussiness/paas/wrapbg1.png"), content:'跨数据中心调度GPU/TPU集群，实现千卡级异构算力协同，支持百亿参数模型的并行训练与弹性扩缩容。' },
                        { title: '突发性科研计算', wrapPic: require("@/assets/images/bussiness/paas/wrapbg2.png"), content:'为气象预测、基因测序等超算需求提供秒级资源响应，通过智能编排自动匹配CPU/GPU/FPGA混合架构资源。' },
                        { title: '边缘实时推理', wrapPic: require("@/assets/images/bussiness/paas/wrapbg3.png"), content:'在5G基站、工厂园区等边缘节点部署低延迟推理服务，实现视频分析、工业质检等场景的端边云协同计算。' },
                        { title: '算力资源共享交易', wrapPic: require("@/assets/images/bussiness/paas/wrapbg4.png"), content:'通过算力网关接入社会闲置算力，构建P2P算力市场，满足中小企业的弹性算力需求' },
                    ],
                    productGoodsList: [
                        { title: '存算协同优化', wrapPic: require("@/assets/images/bussiness/paas/wrapbg6.png"), content:'采用计算靠近数据架构，减少80%数据搬迁开销' },
                        { title: '全域资源覆盖', wrapPic: require("@/assets/images/bussiness/paas/wrapbg7.png"), content:'通过统一API网关实现多云资源混合调度，多云无感切换' },
                        { title: '数字主权保障', wrapPic: require("@/assets/images/bussiness/paas/wrapbg8.png"), content:'通过"数据不出域，算力可流通"机制，满足《数据安全法》三级等保要求' },
                        { title: '算力-电力协同优化', wrapPic: require("@/assets/images/bussiness/paas/wrapbg9.png"), content:'动态匹配西部可再生能源（如风电、光伏）与算力负载，绿色算力占比超40%，年减碳量达百万吨级' },
                    ],
                    productCapacityList:[
                        { title:'统一算力调度与管理', content:'平台整合通用计算、智能算力、高性能算力及边缘算力资源，实现跨厂商、跨地域的资源动态分配，支持毫秒级任务分发，提升资源利用率至78%以上。' },
                        { title:'全局调度优化', content:'通过云边端协同机制，可按需调配从数据中心到终端设备的立体算力网络，基于意图感知的分布式调度算法，自动匹配科学计算、AI训练、实时推理等混合负载需求。' },
                        { title:'国产化全栈融合架构', content:'兼容CPU/GPU/NPU等多元芯片架构，深度兼容昇腾、海光、寒武纪等国产芯片，以及欧拉、龙蜥、麒麟、统信等国产操作系统。支持云原生技术（如Kubernetes），满足IaaS、PaaS、SaaS多层次服务，降低成本并缩短部署周期。' },
                        { title:'内生安全与合规', content:'深度融合安全防护，涵盖容器安全、API网关、数据加密及模型可信验证，满足信创要求，确保全链路合规。' },
                    ],
                    caseList: [
                        { title: '南京智算中心和青海智算中心资源整合调度', wrapPic: require("@/assets/images/bussiness/paas/paas_wrapbg4.png"), content:"" },
                    ]
                }
            }
        }
    }
}
</script>